import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                orangeMain: '#FFAA00',
                orangeDark: '#F39314',
                blueMain: '#383F61',
                blueGrey: '#686F8A',
                blueLigth: '#868EAA',
                blueDark: '#2D324B',
            },
        },
    },
});

